export const BuildingType = {
    MANOR_HOUSE: 'manor_house',
    TIMBER_CAMP: 'timber_camp',
    CLAY_PIT: 'clay_pit',
    IRON_MINE: 'iron_mine',
    FARM: 'farm',
    WAREHOUSE: 'warehouse',
    BARRACKS: 'barracks',
    SMITHY: 'smithy',
    STABLE: 'stable',
    MARKET: 'market',
    WALL: 'wall',
    DOCKYARD: 'dockyard',
    CHURCH: 'church',
};
export const BUILDING_TYPES = Object.values(BuildingType);
export const QueueStatus = {
    PENDING: 'pending',
    COMPLETED: 'completed',
    CANCELLED: 'cancelled',
};
export const TerrainType = {
    OCEAN: 'ocean',
    SHALLOWS: 'shallows',
    PLAINS: 'plains',
    FOREST: 'forest',
    HILLS: 'hills',
    MOUNTAIN: 'mountain',
};
/**
 * One character per terrain, so a map chunk can travel as a plain string
 * instead of an array of objects. A 201x201 view is 40KB of text that gzips to
 * almost nothing, against ~4MB of JSON for the equivalent tile objects.
 */
export const TERRAIN_CODES = {
    ocean: 'o',
    shallows: 's',
    plains: 'p',
    forest: 'f',
    hills: 'h',
    mountain: 'm',
};
export const TERRAIN_BY_CODE = {
    o: TerrainType.OCEAN,
    s: TerrainType.SHALLOWS,
    p: TerrainType.PLAINS,
    f: TerrainType.FOREST,
    h: TerrainType.HILLS,
    m: TerrainType.MOUNTAIN,
};
/** Villages can only stand on dry, non-mountainous ground. */
export const BUILDABLE_TERRAIN = [
    TerrainType.PLAINS,
    TerrainType.FOREST,
    TerrainType.HILLS,
];
export function isBuildableTerrain(terrain) {
    return BUILDABLE_TERRAIN.includes(terrain);
}
/** Average colour per terrain, used when tiles are too small to texture. */
export const TERRAIN_COLOURS = {
    ocean: '#12283f',
    shallows: '#3f8296',
    plains: '#5c8442',
    forest: '#2f5228',
    hills: '#96794a',
    mountain: '#6e6a66',
};
//# sourceMappingURL=village.js.map